"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class RecalculateChargesFilterValidator extends GenericValidator_1.default {
    _dateSchema = joi_1.default.object({
        from: joi_1.default.number().required(),
        to: joi_1.default.number().required(),
    });
    _recalculateChargesFilterSchema = joi_1.default.object({
        date: this._dateSchema.optional(),
        transactionId: joi_1.default.number().optional(),
        wmsCustomerId: joi_1.default.number().optional(),
    })
        .xor('transactionId', 'date')
        .required();
    validate(recalculateChargesFilter) {
        super.validate(recalculateChargesFilter, 'IRecalculateChargesFilter', this._recalculateChargesFilterSchema);
    }
}
exports.default = RecalculateChargesFilterValidator;
